//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useContext, useEffect, useState } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { Grid, makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { LayoutContext } from '../../common/contexts';
import { numberWithCommas } from '../../common/textHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
// import SearchInput from './SearchInput';
// import AfitdButton from '../../common/elemental/AfitdButton';
// import RotateLeftIcon from '@material-ui/icons/RotateLeft';
// import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import ContactUsTable from './Tables/ContactUsTable';
import { loadContactUsData } from '../../common/services/adminServices';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';
import _slice from 'lodash/slice';
import { format } from 'date-fns';
// import format from 'date-fns/format';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {},
        headerTitle: { fontWeight: 'bold', fontSize: 20 },
        topBarRightItem: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' },
        passwordResetButton: { height: 36, marginRight: 8 },
        selectedText: { paddingRight: 16 },
        deleteButton: { height: 36 },
        topBarContainer: { height: 57.66, border: '1px solid #F3F3F3', padding: '0px 10px', width: 1084, marginLeft: '-2px', borderRadius: '4px 4px 0px 0px' },
        recordsText: { fontSize: 18 },
        numberText: { fontSize: 19, color: '#0BAA89', fontWeight: 'bold' },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        root: { item: true, xl: 9, lg: 9, md: 9, sm: 9, xs: 9 },
        passwordResetButton: { color: 'secondary' },
        topBarContainer: { container: true, alignItems: 'center' },
        topBarLeftItem: { item: true, xl: 7, xs: 7 },
        topBarRightItem: { item: true, xl: 5, xs: 5 },
        selectedText: { color: 'secondary' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ContactUs = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    const layoutContext = useContext(LayoutContext);
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;
    const { totalCounts, todayCount } = layoutContext;
    const totalCount = totalCounts?.contactUsCount || 0;
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    // const layoutContext = useContext(LayoutContext);
    // const { scrollToPageTop } = layoutContext;
    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states

    //---------------------------------------------------------------------
    const [selected, setSelected] = useState([]);
    const [data, setData] = React.useState([]);
    const [queryCursors, setQueryCursors] = React.useState([]);
    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    useEffect(() => {
        const loadData = async () => {
            const { result, lastDoc } = await loadContactUsData({ setData, setQueryCursors });
            setData(result);
            setQueryCursors(prev => [...prev, lastDoc]); // add cursor
        };
        loadData();
    }, []);
    //-------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickPrev = async () => {
        const { result, lastDoc } = await loadContactUsData({ queryCursors, mode: 'prev' });
        setData(result);
        setQueryCursors(prev => [..._slice(prev, 0, prev.length - 2), lastDoc]); // remove last cursor
    };

    const handleClickNext = async () => {
        const { result, lastDoc } = await loadContactUsData({ queryCursors }); // default mode is 'next'
        setData(result);
        setQueryCursors(prev => [...prev, lastDoc]); // add cursor
    };
    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.root}>
            <div>
                <p {...defns.headerTitle}>Contact Us</p>
            </div>
            <div>
                <p {...defns.recordsText}>
                    Total Records : <span {...defns.numberText}>{numberWithCommas(totalCount)}</span>
                    <br />
                    Added Today ({format(new Date(), 'MM/dd/yyyy')}): <span {...defns.numberText}>{todayCount?.contactUsCount || 0}</span>
                </p>
            </div>

            <ContactUsTable prevOnClick={handleClickPrev} nextOnClick={handleClickNext} data={data} selected={selected} setSelected={setSelected} />
        </Grid>
    );
};

export default ContactUs;
